import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { SharedAuthService } from '../../services/shared-auth.service';
import { SharedStorageKeyEnum } from 'src/app/shared/_config/storage/shared-storage-key-enum';
import * as navConstants from 'src/app/shared/routing/routing.const';
import { SpxStorage, SpxStorageKeyEnum } from '@softpak/components/spx-storage';

@Injectable({
  providedIn: 'root'
})
export class SharedSignInGuard  {
  private readonly router = inject(Router);
  private readonly sharedAuthService = inject(SharedAuthService);


  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if ((!this.sharedAuthService.loggedIn || this.sharedAuthService.loggedIn === undefined) || SpxStorage.getChannelSetting<SharedStorageKeyEnum>(SpxStorageKeyEnum.token) === undefined ||
      !SpxStorage.getChannelSetting<SharedStorageKeyEnum>(SpxStorageKeyEnum.token)) {
      SpxStorage.setSetting<SharedStorageKeyEnum>(SpxStorageKeyEnum.afterSignIn, state.url);
      this.router.navigate([
        navConstants.navHmeSignInUrl
      ]);
      return false;
    }
    return true;
  }
}
